// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-hero {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2rem;
  padding: 2rem 1rem;
  text-align: left;
}

.landing-hero__content {
  flex: 1 1 340px;
}

.landing-hero__eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.15em;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #267833;
}

.landing-hero__text {
  margin: 1rem 0;
  max-width: 480px;
}

.landing-hero__byline {
  margin: 0.5rem 0 1.5rem;
  font-size: 0.95rem;
  color: #2b3b2a;
}

.landing-hero__byline a {
  color: #1d5b28;
  font-weight: 600;
  text-decoration: none;
}
.landing-hero__byline a:hover {
  text-decoration: underline;
}

.landing-hero__actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
}

.landing-hero__statement {
  font-weight: 500;
  margin-bottom: 1rem;
  color: #1f361d;
}

.contact-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #1d5b28;
  color: #fff !important;
  padding: 0.5rem 1.5rem;
  border-radius: 999px;
  text-decoration: none;
  font-weight: 600;
}

.contact-btn:hover {
  background: #277a38;
}

.landing-hero__artwork {
  flex: 1 1 260px;
  text-align: center;
}

.landing-hero__artwork img {
  max-width: 320px;
  width: 100%;
}

.landing-section {
  padding: 2rem 1rem;
}

.landing-section--light {
  background: #f5f7f5;
}

.landing-section--dark {
  background: #1f2a1f;
  color: #fff;
}

.features {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
  margin: 1.5rem auto 0;
}

.feature-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  min-height: 180px;
  text-align: center;
  width: 280px;
  max-width: 90vw;
}

.feature-card h3 {
  margin-top: 0;
}

.feature-card__badge {
  display: inline-block;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #267833;
  margin-bottom: 0.5rem;
}

.landing-lead {
  max-width: 640px;
  margin: 0 auto 1.5rem auto;
  text-align: center;
}

.screenshots {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
  max-width: 1120px;
  margin: 0 auto;
}

.screenshot-card {
  border-radius: 16px;
  overflow: hidden;
  background: white;
  display: flex;
  flex-direction: column;
  width: clamp(320px, 28vw, 400px);
  max-width: 95vw;
  height: 470px;
  text-align: center;
  cursor: zoom-in;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.screenshot-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.12);
}

.screenshot-card:focus,
.screenshot-card:focus-visible {
  outline: 2px solid #267833;
  outline-offset: 4px;
}

.screenshot-card__media {
  flex: 1 1 260px;
  min-height: 320px;
  background: linear-gradient(135deg, #f8faf8, #e6ede6);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem;
}

.screenshot-card__media img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.screenshot-card__body {
  flex: 0 0 auto;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.25rem;
}

.screenshot-card__body {
  padding: 1.5rem;
}

.screenshot-lightbox {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  z-index: 1000;
}

.screenshot-lightbox__dialog {
  position: relative;
  background: #f8faf8;
  border-radius: 14px;
  padding: 1rem 1rem 1.5rem;
  max-width: min(1200px, 95vw);
  max-height: 92vh;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.28);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.screenshot-lightbox__dialog img {
  max-width: 100%;
  max-height: 78vh;
  object-fit: contain;
  border-radius: 10px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.25);
}

.screenshot-lightbox__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  border: none;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 1.25rem;
  cursor: pointer;
}

.screenshot-lightbox__close:hover {
  background: rgba(0, 0, 0, 0.8);
}

.screenshot-lightbox__caption {
  margin: 0;
  text-align: center;
  color: #1f361d;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.workflow {
  max-width: 960px;
  margin: 0 auto;
}

.workflow__intro {
  text-align: center;
}

.workflow__steps {
  list-style: none;
  margin: 2rem auto 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
  max-width: 960px;
}

.workflow__steps li {
  background: rgba(255, 255, 255, 0.05);
  padding: 1.25rem;
  border-radius: 12px;
  min-height: 150px;
  width: 280px;
  max-width: 90vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: left;
}

.workflow__steps li strong {
  display: block;
  margin-bottom: 0.5rem;
}

.cta-card {
  max-width: 700px;
  margin: 0 auto;
  padding: 2rem;
  border-radius: 16px;
  background: white;
  text-align: center;
}

.contact-details {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  margin-top: 1rem;
  align-items: center;
}

.contact-link {
  color: #1d5b28;
  font-weight: 600;
  text-decoration: none;
}

.contact-person {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
}

.contact-link:hover {
  text-decoration: underline;
}

.contact-note {
  color: #4a5c41;
  font-size: 0.9rem;
}

.feature-card,
.screenshot-card {
  text-align: center;
}

.workflow__steps li {
  text-align: left;
}

.landing-video {
  background: #f5f7f5;
}

.landing-video__content {
  max-width: 1040px;
  margin: 0 auto;
  padding: 2rem;
  border-radius: 16px;
  background: #ffffff;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  align-items: center;
}

.landing-video__eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 0.82rem;
  color: #267833;
  margin: 0 0 0.35rem;
}

.landing-video__frame {
  width: 100%;
}

.video-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
}

.video-wrapper iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.demo-card {
  max-width: 1040px;
  margin: 0 auto;
  padding: 2rem;
  border-radius: 16px;
  background: #ffffff;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  align-items: center;
}

.demo-card__intro {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.demo-card__eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.8rem;
  color: #267833;
  margin: 0;
}

.demo-card__logins {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
}

.login-tile {
  background: #f8faf8;
  border-radius: 14px;
  padding: 1rem 1.25rem;
}

.login-tile__role {
  margin: 0 0 0.35rem;
  font-weight: 700;
  color: #1d5b28;
}

.login-tile__cred {
  margin: 0.1rem 0;
  font-family: 'Courier New', Courier, monospace;
}

.landing-section--brand {
  background: #f9fdf8;
}

.brand-card {
  max-width: 860px;
  margin: 0 auto;
  padding: 2rem;
  border-radius: 18px;
  background: white;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.brand-card__media {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

.brand-card__logo-wrapper {
  background: #000;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand-card__logo {
  height: 70px;
  width: auto;
  object-fit: contain;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.4));
}

.brand-card__portrait {
  margin: 0;
  max-width: 280px;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
}

.brand-card__portrait img {
  width: 100%;
  display: block;
  object-fit: cover;
}

.brand-card__portrait figcaption {
  font-size: 0.8rem;
  padding: 0.4rem 0.6rem;
  color: #4a5c41;
}

.brand-card__highlights {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-top: 0.5rem;
}

.brand-card__highlights span {
  display: block;
  padding-left: 1.25rem;
  position: relative;
}

.brand-card__highlights span::before {
  content: '•';
  position: absolute;
  left: 0;
  color: #267833;
}

.brand-card__eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 0.8rem;
  color: #267833;
  margin: 0;
}

.brand-card__link {
  align-self: flex-start;
  font-weight: 600;
  color: #1d5b28;
  text-decoration: none;
}

.brand-card__link:hover {
  text-decoration: underline;
}

.landing-section--testimonial {
  background: #fff;
}

.testimonial-card {
  max-width: 860px;
  margin: 0 auto;
  padding: 2rem;
  border-radius: 18px;
  background: #f7faf6;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.testimonial-card__eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 0.8rem;
  color: #267833;
  margin: 0;
}

.testimonial-card__quote {
  font-style: italic;
  color: #1d3f1a;
  margin-bottom: 0;
}

.testimonial-card__photo {
  margin: 0 auto;
  max-width: 360px;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  width: 100%;
}

.testimonial-card__photo img {
  width: 100%;
  display: block;
  object-fit: cover;
}

.testimonial-card__photo figcaption {
  font-size: 0.85rem;
  padding: 0.5rem 0;
  color: #4a5c41;
}

.testimonial-card__link {
  align-self: flex-start;
  font-weight: 600;
  color: #1d5b28;
  text-decoration: none;
}

.testimonial-card__link:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/app/landing/landing.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".landing-hero {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 2rem;\n  padding: 2rem 1rem;\n  text-align: left;\n}\n\n.landing-hero__content {\n  flex: 1 1 340px;\n}\n\n.landing-hero__eyebrow {\n  text-transform: uppercase;\n  letter-spacing: 0.15em;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: #267833;\n}\n\n.landing-hero__text {\n  margin: 1rem 0;\n  max-width: 480px;\n}\n\n.landing-hero__byline {\n  margin: 0.5rem 0 1.5rem;\n  font-size: 0.95rem;\n  color: #2b3b2a;\n}\n\n.landing-hero__byline a {\n  color: #1d5b28;\n  font-weight: 600;\n  text-decoration: none;\n}\n.landing-hero__byline a:hover {\n  text-decoration: underline;\n}\n\n.landing-hero__actions {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.landing-hero__statement {\n  font-weight: 500;\n  margin-bottom: 1rem;\n  color: #1f361d;\n}\n\n.contact-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #1d5b28;\n  color: #fff !important;\n  padding: 0.5rem 1.5rem;\n  border-radius: 999px;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.contact-btn:hover {\n  background: #277a38;\n}\n\n.landing-hero__artwork {\n  flex: 1 1 260px;\n  text-align: center;\n}\n\n.landing-hero__artwork img {\n  max-width: 320px;\n  width: 100%;\n}\n\n.landing-section {\n  padding: 2rem 1rem;\n}\n\n.landing-section--light {\n  background: #f5f7f5;\n}\n\n.landing-section--dark {\n  background: #1f2a1f;\n  color: #fff;\n}\n\n.features {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1.5rem;\n  margin: 1.5rem auto 0;\n}\n\n.feature-card {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);\n  min-height: 180px;\n  text-align: center;\n  width: 280px;\n  max-width: 90vw;\n}\n\n.feature-card h3 {\n  margin-top: 0;\n}\n\n.feature-card__badge {\n  display: inline-block;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #267833;\n  margin-bottom: 0.5rem;\n}\n\n.landing-lead {\n  max-width: 640px;\n  margin: 0 auto 1.5rem auto;\n  text-align: center;\n}\n\n.screenshots {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1.5rem;\n  max-width: 1120px;\n  margin: 0 auto;\n}\n\n.screenshot-card {\n  border-radius: 16px;\n  overflow: hidden;\n  background: white;\n  display: flex;\n  flex-direction: column;\n  width: clamp(320px, 28vw, 400px);\n  max-width: 95vw;\n  height: 470px;\n  text-align: center;\n  cursor: zoom-in;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.screenshot-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.12);\n}\n\n.screenshot-card:focus,\n.screenshot-card:focus-visible {\n  outline: 2px solid #267833;\n  outline-offset: 4px;\n}\n\n.screenshot-card__media {\n  flex: 1 1 260px;\n  min-height: 320px;\n  background: linear-gradient(135deg, #f8faf8, #e6ede6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.75rem;\n}\n\n.screenshot-card__media img {\n  max-width: 100%;\n  max-height: 100%;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n}\n\n.screenshot-card__body {\n  flex: 0 0 auto;\n  min-height: 140px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 1.25rem;\n}\n\n.screenshot-card__body {\n  padding: 1.5rem;\n}\n\n.screenshot-lightbox {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.65);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  z-index: 1000;\n}\n\n.screenshot-lightbox__dialog {\n  position: relative;\n  background: #f8faf8;\n  border-radius: 14px;\n  padding: 1rem 1rem 1.5rem;\n  max-width: min(1200px, 95vw);\n  max-height: 92vh;\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.28);\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.screenshot-lightbox__dialog img {\n  max-width: 100%;\n  max-height: 78vh;\n  object-fit: contain;\n  border-radius: 10px;\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.25);\n}\n\n.screenshot-lightbox__close {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  border: none;\n  background: rgba(0, 0, 0, 0.65);\n  color: #fff;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  font-size: 1.25rem;\n  cursor: pointer;\n}\n\n.screenshot-lightbox__close:hover {\n  background: rgba(0, 0, 0, 0.8);\n}\n\n.screenshot-lightbox__caption {\n  margin: 0;\n  text-align: center;\n  color: #1f361d;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.workflow {\n  max-width: 960px;\n  margin: 0 auto;\n}\n\n.workflow__intro {\n  text-align: center;\n}\n\n.workflow__steps {\n  list-style: none;\n  margin: 2rem auto 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1.5rem;\n  max-width: 960px;\n}\n\n.workflow__steps li {\n  background: rgba(255, 255, 255, 0.05);\n  padding: 1.25rem;\n  border-radius: 12px;\n  min-height: 150px;\n  width: 280px;\n  max-width: 90vw;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  text-align: left;\n}\n\n.workflow__steps li strong {\n  display: block;\n  margin-bottom: 0.5rem;\n}\n\n.cta-card {\n  max-width: 700px;\n  margin: 0 auto;\n  padding: 2rem;\n  border-radius: 16px;\n  background: white;\n  text-align: center;\n}\n\n.contact-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  margin-top: 1rem;\n  align-items: center;\n}\n\n.contact-link {\n  color: #1d5b28;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.contact-person {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.2rem;\n}\n\n.contact-link:hover {\n  text-decoration: underline;\n}\n\n.contact-note {\n  color: #4a5c41;\n  font-size: 0.9rem;\n}\n\n.feature-card,\n.screenshot-card {\n  text-align: center;\n}\n\n.workflow__steps li {\n  text-align: left;\n}\n\n.landing-video {\n  background: #f5f7f5;\n}\n\n.landing-video__content {\n  max-width: 1040px;\n  margin: 0 auto;\n  padding: 2rem;\n  border-radius: 16px;\n  background: #ffffff;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n  align-items: center;\n}\n\n.landing-video__eyebrow {\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  font-size: 0.82rem;\n  color: #267833;\n  margin: 0 0 0.35rem;\n}\n\n.landing-video__frame {\n  width: 100%;\n}\n\n.video-wrapper {\n  position: relative;\n  width: 100%;\n  padding-bottom: 56.25%;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);\n}\n\n.video-wrapper iframe {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n.demo-card {\n  max-width: 1040px;\n  margin: 0 auto;\n  padding: 2rem;\n  border-radius: 16px;\n  background: #ffffff;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n  align-items: center;\n}\n\n.demo-card__intro {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.demo-card__eyebrow {\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 0.8rem;\n  color: #267833;\n  margin: 0;\n}\n\n.demo-card__logins {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.login-tile {\n  background: #f8faf8;\n  border-radius: 14px;\n  padding: 1rem 1.25rem;\n}\n\n.login-tile__role {\n  margin: 0 0 0.35rem;\n  font-weight: 700;\n  color: #1d5b28;\n}\n\n.login-tile__cred {\n  margin: 0.1rem 0;\n  font-family: 'Courier New', Courier, monospace;\n}\n\n.landing-section--brand {\n  background: #f9fdf8;\n}\n\n.brand-card {\n  max-width: 860px;\n  margin: 0 auto;\n  padding: 2rem;\n  border-radius: 18px;\n  background: white;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.brand-card__media {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1rem;\n}\n\n.brand-card__logo-wrapper {\n  background: #000;\n  padding: 0.75rem 1rem;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.brand-card__logo {\n  height: 70px;\n  width: auto;\n  object-fit: contain;\n  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.4));\n}\n\n.brand-card__portrait {\n  margin: 0;\n  max-width: 280px;\n  border-radius: 16px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.brand-card__portrait img {\n  width: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.brand-card__portrait figcaption {\n  font-size: 0.8rem;\n  padding: 0.4rem 0.6rem;\n  color: #4a5c41;\n}\n\n.brand-card__highlights {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin-top: 0.5rem;\n}\n\n.brand-card__highlights span {\n  display: block;\n  padding-left: 1.25rem;\n  position: relative;\n}\n\n.brand-card__highlights span::before {\n  content: '•';\n  position: absolute;\n  left: 0;\n  color: #267833;\n}\n\n.brand-card__eyebrow {\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  font-size: 0.8rem;\n  color: #267833;\n  margin: 0;\n}\n\n.brand-card__link {\n  align-self: flex-start;\n  font-weight: 600;\n  color: #1d5b28;\n  text-decoration: none;\n}\n\n.brand-card__link:hover {\n  text-decoration: underline;\n}\n\n.landing-section--testimonial {\n  background: #fff;\n}\n\n.testimonial-card {\n  max-width: 860px;\n  margin: 0 auto;\n  padding: 2rem;\n  border-radius: 18px;\n  background: #f7faf6;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.testimonial-card__eyebrow {\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  font-size: 0.8rem;\n  color: #267833;\n  margin: 0;\n}\n\n.testimonial-card__quote {\n  font-style: italic;\n  color: #1d3f1a;\n  margin-bottom: 0;\n}\n\n.testimonial-card__photo {\n  margin: 0 auto;\n  max-width: 360px;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #fff;\n  width: 100%;\n}\n\n.testimonial-card__photo img {\n  width: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.testimonial-card__photo figcaption {\n  font-size: 0.85rem;\n  padding: 0.5rem 0;\n  color: #4a5c41;\n}\n\n.testimonial-card__link {\n  align-self: flex-start;\n  font-weight: 600;\n  color: #1d5b28;\n  text-decoration: none;\n}\n\n.testimonial-card__link:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
